export default __webpack_public_path__ + "static/cppglass-logo-5343446f064e78f4a945a1b0ad3a0dcc.png";